module.exports = __webpack_public_path__ + "img/slide01.64b19a45.jpg";